import { render } from "./TradeRoute.vue?vue&type=template&id=ec172712&scoped=true"
import script from "./TradeRoute.vue?vue&type=script&lang=ts"
export * from "./TradeRoute.vue?vue&type=script&lang=ts"

import "./TradeRoute.vue?vue&type=style&index=0&id=ec172712&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ec172712"

export default script